import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { productName } from '../data/offer';
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const show = window.setTimeout(() => setVisible(true), 5000);
    const hide = window.setTimeout(() => setVisible(false), 15000);
    return () => {
      window.clearTimeout(show);
      window.clearTimeout(hide);
    };
  }, []);
  return <AnimatePresence data-id="element-204" data-mp="21yd7e5kovwrt">
      {visible && <motion.aside initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 14
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-4 right-4 z-50 w-[calc(100%-2rem)] max-w-sm rounded-lg border border-silverEdge border-l-4 border-l-silver bg-navyPanel p-4 pr-10 text-silverBright shadow-lift" aria-live="polite" data-id="element-205" data-mp="1wxxxjnzm97el">
          <button type="button" onClick={() => setVisible(false)} className="absolute right-2 top-2 rounded p-1 text-silverDark transition-colors duration-150 ease-out hover:text-silverBright focus:outline-none focus-visible:ring-2 focus-visible:ring-silver" aria-label="Dismiss notice" data-id="element-206" data-mp="1sgfs9qnz2eh0">
            <XIcon className="h-4 w-4" data-id="element-207" data-mp="19poiwp3zio2m" />
          </button>
          <div className="flex gap-3" data-id="element-208" data-mp="19o3pj2tepb6c">
            <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-silver" aria-hidden="true" data-id="element-209" data-mp="1efv8osa8gemg" />
            <div data-id="element-210" data-mp="zrig85actdwp">
              <p className="text-[10px] font-extrabold uppercase tracking-[.16em] text-silver" data-id="element-211" data-mp="zs0f79oei68b">Access confirmed</p>
              <p className="mt-1 text-sm leading-snug" data-id="element-212" data-mp="14r3k8u4dscga">
                Once your purchase is complete you receive the
                <br data-id="element-213" data-mp="qrc7sxtij44e" />
                <span className="font-bold text-white" data-id="element-214" data-mp="qswvc3hetmsr">{productName}</span>
              </p>
              <p className="mt-2 text-xs text-silverDark" data-id="element-215" data-mp="vrgg40k9osjj">Instant digital access by email</p>
            </div>
          </div>
        </motion.aside>}
    </AnimatePresence>;
}